import { call, put, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../../services/apis";

export function* handleFetchPackage({ payload }) {
  try {
    const res = yield call(API.fetchPackage, payload);
    const { data } = res;
    yield put(actions.fetchPackageSuccess(data));
  } catch (err) {
    yield put(actions.fetchPackageFailure(err?.response?.data));
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export function* packageDetailsSaga() {
  yield takeLatest(actions.fetchPackage.type, handleFetchPackage);
}
